/** @typedef {'header'|'letter'|'number'} ColumnReference */

/**
 * @param {string} header
 * @returns {string}
 */
export function headerToKey(header) {
  const raw = String(header || '').trim();
  if (!raw) return 'column';

  const parts = raw.split(/[^a-zA-Z0-9]+/).filter(Boolean);
  if (parts.length === 0) return 'column';

  return parts
    .map((part, index) => {
      const lower = part.toLowerCase();
      if (index === 0) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join('');
}

/**
 * Apps Script URL query param from a sheet header (camelCase, word chars only).
 * @param {string} header
 * @returns {string}
 */
export function headerToUrlParam(header) {
  const key = headerToKey(header).replace(/[^\w]/g, '');
  return key || 'id';
}

/**
 * @param {number} index 0-based
 * @returns {string}
 */
export function indexToLetter(index) {
  let n = index;
  let letters = '';
  while (n >= 0) {
    letters = String.fromCharCode((n % 26) + 65) + letters;
    n = Math.floor(n / 26) - 1;
  }
  return letters;
}

/**
 * @param {string} letter
 * @returns {number} 0-based index
 */
export function letterToIndex(letter) {
  const s = String(letter || 'A')
    .trim()
    .toUpperCase();
  if (!s) return 0;

  let index = 0;
  for (let i = 0; i < s.length; i += 1) {
    index = index * 26 + (s.charCodeAt(i) - 64);
  }
  return index - 1;
}

/**
 * @param {number} number 1-based column number
 * @returns {number} 0-based index
 */
export function numberToIndex(number) {
  const n = parseInt(String(number), 10);
  if (Number.isNaN(n) || n < 1) return 0;
  return n - 1;
}

/**
 * @param {ColumnReference} reference
 * @param {number} position 0-based position in column list
 * @returns {number}
 */
export function referenceToIndex(reference, position) {
  if (reference === 'number') return position;
  return position;
}
